var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F3F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6589 22L19.6429 14.8H21.7229L17.6429 22H15.6589ZM15.6589 23.12V22L16.4429 21.472H24.3469V23.12H15.6589ZM20.9709 26V18.672H22.7789V26H20.9709Z",
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileStep4);
export default __webpack_public_path__ + "static/media/mobile-step4.78549e9fd7196da51450d576c169d9cb.svg";
export { ForwardRef as ReactComponent };